/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppDynamicWrapper.vue?vue&type=template&id=77077a98"
import script from "./AppDynamicWrapper.ts?vue&type=script&lang=ts&external"
export * from "./AppDynamicWrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports